import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "src/apps/hooks/useAuth";
import { LoadingScreen } from "../../components/loading/LoadingScreen";
import { DOCUMENTATION_AREA_ROUTES } from "../Navigation";
import { useBrowserLocalStorage } from "../../hooks/useBrowserLocalStorage";
import { useSlug } from "../../hooks/useSlug";

export const CallbackScreen = () => {
  const navigate = useNavigate();
  const { setToken, token } = useAuth();
  const { linkType, slug } = useSlug();

  const [_, setTokenToLocalStorage] = useBrowserLocalStorage<string | null>(
    `stored_query_param.token.${linkType}.${slug}`,
    null,
  );

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.hash.substring(1));
    const accessToken = searchParams.get("access_token");

    if (!searchParams || !accessToken)
      return navigate({ pathname: DOCUMENTATION_AREA_ROUTES.LOGIN, search: location.search });

    setToken(accessToken);
    setTokenToLocalStorage(accessToken);
  }, []);

  useEffect(() => {
    if (token) {
      navigate({ pathname: DOCUMENTATION_AREA_ROUTES.HOME, search: location.search });
    }
  }, [token, navigate]);

  return <LoadingScreen />;
};
